/* 

Ajax Single Category + Search 

Arguments:

formID = ID of filter form
selectID = ID of category drop down
searchID = ID of search field

*/

const ajaxFormSubmit = (formID, selectID, searchID, container, action, buttonID ) => {
    // define filter form ID
    const form = document.querySelector('#'+formID)

    const button = document.querySelector('#'+buttonID);

    if(typeof (form) !== 'undefined' && form !== null) {

        form.addEventListener('submit', (e) => {

            // Get id from category dropdown
            const category = document.querySelector('#'+selectID)
            // Get id from search input
            const search = document.querySelector('#'+searchID)
            // Define surrounding containers
            let postsParentContainer = document.querySelector('#'+container)
            let postsContainer = document.querySelector('#'+container+' .row')

            postsParentContainer.setAttribute('data-page', 1);

            // Pass form values to POST parameters
            let params = new URLSearchParams();
            // Define form action defined in hidden field
            params.append('action', action);

            // EX: selected_cat is the POST Variable
            params.append('gzr__category', category.value);

            // EX: search_results is the POST Variable
            params.append('gzr__search', search.value);

            // Send http request via Axios
            axios.post('/wp-admin/admin-ajax.php', params)
            .then(res => {
                  
                postsContainer.innerHTML = res.data;

                if (postsParentContainer.dataset.page === postsParentContainer.dataset.max - 1 || postsParentContainer.dataset.max <= 1) {
                    
                    button.style.display = 'none';

                } else {

                    button.style.display = 'block';
                
                }
                
                

            });

            e.preventDefault();

        });
        
    }
}

// Ajax - Load More Posts

const ajaxLoadMore = (buttonID, selectID, searchID, action, container) => {

    const button = document.querySelector('#'+buttonID);

    if(typeof (button) !== 'undefined' && button !== null) {
        
        button.addEventListener('click', (e) => {

            // Get id from category dropdown
            const category = document.querySelector('#'+selectID)
            // Get id from search input
            const search = document.querySelector('#'+searchID)
            let postsParentContainer = document.querySelector('#'+container)
            let postsContainer = document.querySelector('#'+container+' .row')

         

            let current_page = postsParentContainer.dataset.page;
            //let max_pages = document.querySelector('.job-card-container').dataset.max;
            

            let params = new URLSearchParams();
            params.append('action', action);
            params.append('current_page', current_page);
            // EX: selected_cat is the POST Variable
            params.append('gzr__category', category.value);
            // EX: search_results is the POST Variable
            params.append('gzr__search', search.value);
            
         


            axios.post('/wp-admin/admin-ajax.php', params)
            .then(res => {
                
                postsContainer.innerHTML += res.data.data;

                /*let getUrl = window.location;
                let baseUrl = getUrl.protocol + "//" + getUrl.host + "/";

                window.history.pushState('', '', baseUrl + '4-0-completed-searches/page/' + (parseInt(document.querySelector('.job-card-container').dataset.page) + 1));*/

                if (postsParentContainer.dataset.page == postsParentContainer.dataset.max - 1 || postsParentContainer.dataset.max <= 1) {
                    
                    button.style.display = 'none';

                } else {

                    button.style.display = 'block';
                    postsParentContainer.dataset.page++;
                }
                

            });

        });

    }

}

// Ajax - Update Post Offset

const updateOffset = (formID, buttonID, selectID, searchID, action, container) => {

    // define filter form ID
    const form = document.querySelector('#'+formID)

    if(typeof (form) !== 'undefined' && form !== null) {
        
        form.addEventListener('submit', (e) => {

            // Get id from category dropdown
            const category = document.querySelector('#'+selectID)
            // Get id from search input
            const search = document.querySelector('#'+searchID)
            const button = document.querySelector('#'+buttonID);
        

            let postsParentContainer = document.querySelector('#'+container)
            

            let params = new URLSearchParams();
            params.append('action', action);
        
            params.append('gzr__category', category.value);
            // EX: search_results is the POST Variable
            params.append('gzr__search', search.value);
    


            axios.post('/wp-admin/admin-ajax.php', params)
            .then(res => {
                
                postsParentContainer.setAttribute('data-max', res.data.maxpages);

                if(res.data.maxpages > 1) {
                    button.style.display = 'inline-block';
                 
                }

                if(res.data.maxpages <= 1) {
                    button.style.display = 'none';
                  
                }

                if(res.data.maxpages == 0) {
                    button.style.display = 'none';
                  
                }

            });

        });


    }

}


// Ajax - Load More Posts (Load more only no filter attached)

const ajaxLoadMoreOnly = (buttonID, action, container) => {

    const button = document.querySelector('#'+buttonID);

    let postsParentContainer = document.querySelector('#'+container)
    let postsContainer = document.querySelector('#'+container+' .row')

    // Check count of maxpages on load


    if(typeof (button) !== 'undefined' && button !== null) {

        if(postsParentContainer.dataset.page == postsParentContainer.dataset.max -1 || postsParentContainer.dataset.max <= 1){
            button.style.display = 'none';
        }
            
        button.addEventListener('click', (e) => {

            let current_page = postsParentContainer.dataset.page;
            //let max_pages = document.querySelector('.job-card-container').dataset.max;
            

            let params = new URLSearchParams();
            params.append('action', action);
            params.append('current_page', current_page);
  
            

            axios.post('/wp-admin/admin-ajax.php', params)
            .then(res => {
                
                postsContainer.innerHTML += res.data.data;

                if (postsParentContainer.dataset.page == postsParentContainer.dataset.max -1 || postsParentContainer.dataset.max <= 1) {
                    
                    button.style.display = 'none';

                } else {

                    button.style.display = 'block';
                    postsParentContainer.dataset.page++;
                }
                

            });

        });

    }

}




// Run Ajax Functions Here

// Learn Filter Ajax
ajaxFormSubmit(
    'gzr__custom__filter',
    'gzr__category__options',
    'gzr__search__field',
    'dynamic__posts',
    'catfilter',
    'load__more__post-type-here'
)

ajaxLoadMore(
    'load__more__post-type-here',
    'gzr__category__options',
    'gzr__search__field',
    'loadmore',
    'dynamic__posts'
);

updateOffset(
    'gzr__custom__filter',
    'load__more__post-type-here',
    'gzr__category__options',
    'gzr__search__field',
    'updateoffsethandle',
    'dynamic__posts',
)

// News Filter Ajax

ajaxFormSubmit(
    'gzr__custom__filter',
    'gzr__category__options',
    'gzr__search__field',
    'dynamic__posts__news',
    'newsfilter',
    'load__more__news'
)

ajaxLoadMore(
    'load__more__news',
    'gzr__category__options',
    'gzr__search__field',
    'newsloadmore',
    'dynamic__posts__news'
);

updateOffset(
    'gzr__custom__filter',
    'load__more__news',
    'gzr__category__options',
    'gzr__search__field',
    'newsupdateoffsethandle',
    'dynamic__posts__news',
)

// Case Studies Filter ** Load More Only **


ajaxLoadMoreOnly(
    'load__more__casestudies',
    'casestudiesloadmore',
    'dynamic__posts__case-studies'
)

